// // // // src/pages/AboutPage.js
// // // import React from "react";

// // // const AboutPage = () => {
// // //   return (
// // //     <div className="min-h-screen bg-gray-50 py-16 px-6">
// // //       <div className="max-w-3xl mx-auto text-center">
// // //         <h1 className="text-4xl font-bold mb-6 text-gray-900">About Us</h1>
// // //         <p className="text-lg text-gray-600 leading-relaxed">
// // //           Welcome to our store! We provide high-quality products with a focus on
// // //           customer satisfaction. Our mission is to bring you the best shopping
// // //           experience possible, blending style, comfort, and affordability.
// // //         </p>
// // //       </div>
// // //     </div>
// // //   );
// // // };

// // // export default AboutPage;
// // // src/pages/AboutPage.js
// // import React from "react";
// // import { Users, Star, ShoppingBag } from "lucide-react"; // icons

// // const AboutPage = () => {
// //   return (
// //     <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white py-20 px-6">
// //       <div className="max-w-6xl mx-auto">
// //         {/* Hero Section */}
// //         <div className="text-center mb-16">
// //           <h1 className="text-5xl font-extrabold mb-4 bg-gradient-to-r from-yellow-500 to-yellow-700 bg-clip-text text-transparent">
// //             About Our Store
// //           </h1>
// //           <p className="text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed">
// //             We’re more than just a shop — we’re a community of people who love
// //             quality, style, and value. Our mission is to bring you products that
// //             make everyday living easier, brighter, and more beautiful.
// //           </p>
// //         </div>

// //         {/* Values Section */}
// //         <div className="grid md:grid-cols-3 gap-10 text-center mb-20">
// //           <div className="bg-white shadow-sm rounded-xl p-8 hover:shadow-md transition">
// //             <Users className="mx-auto w-12 h-12 text-yellow-600 mb-4" />
// //             <h3 className="text-xl font-semibold mb-2">Customer First</h3>
// //             <p className="text-gray-600">
// //               Every decision we make starts with you. We listen, we care, and we
// //               adapt to make your experience better.
// //             </p>
// //           </div>
// //           <div className="bg-white shadow-sm rounded-xl p-8 hover:shadow-md transition">
// //             <Star className="mx-auto w-12 h-12 text-yellow-600 mb-4" />
// //             <h3 className="text-xl font-semibold mb-2">Quality Products</h3>
// //             <p className="text-gray-600">
// //               We carefully source and test our products to ensure they meet the
// //               highest standards of quality and durability.
// //             </p>
// //           </div>
// //           <div className="bg-white shadow-sm rounded-xl p-8 hover:shadow-md transition">
// //             <ShoppingBag className="mx-auto w-12 h-12 text-yellow-600 mb-4" />
// //             <h3 className="text-xl font-semibold mb-2">Seamless Shopping</h3>
// //             <p className="text-gray-600">
// //               From browsing to checkout, we’ve designed a shopping experience
// //               that’s smooth, simple, and secure.
// //             </p>
// //           </div>
// //         </div>

// //         {/* Story Section */}
// //         <div className="grid md:grid-cols-2 gap-12 items-center">
// //           <div>
// //             <h2 className="text-3xl font-bold mb-4 text-gray-900">
// //               Our Story
// //             </h2>
// //             <p className="text-gray-600 leading-relaxed mb-4">
// //               We started with a simple idea: shopping should be enjoyable, not a
// //               chore. From humble beginnings, we’ve grown into a brand trusted by
// //               thousands of customers. What drives us? A passion for innovation
// //               and a commitment to serving you better every single day.
// //             </p>
// //             <p className="text-gray-600 leading-relaxed">
// //               Whether you’re here for essentials or indulgences, we promise to
// //               deliver products that bring joy and value to your life.
// //             </p>
// //           </div>
// //           <div className="bg-yellow-50 rounded-xl p-6 shadow-sm">
// //             <img
// //               src="https://images.unsplash.com/photo-1523275335684-37898b6baf30?auto=format&fit=crop&w=900&q=80"
// //               alt="Our team at work"
// //               className="rounded-lg object-cover w-full h-80"
// //             />
// //           </div>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default AboutPage;

// import React from "react";

// const AboutPage = () => {
//   return (
//     <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-black">
//       <div className="container mx-auto px-6 py-16">
//         <div className="max-w-6xl mx-auto">
//           {/* Hero Section - Dark Theme */}
//           <div className="text-center mb-16 relative">
//             <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(251,191,36,0.03)_0%,transparent_70%)]"></div>
//             <div className="relative">
//               <h1 className="text-4xl md:text-5xl font-light mb-6 tracking-tight">
//                 <span className="text-white">About Our </span>
//                 <span className="text-yellow-400 font-extralight italic">Legacy</span>
//               </h1>
//               <div className="w-20 h-px bg-gradient-to-r from-transparent via-yellow-400 to-transparent mx-auto mb-6"></div>
//               <p className="text-lg text-gray-300 max-w-2xl mx-auto leading-relaxed font-light">
//                 We're more than just commerce — we're curators of exceptional taste. Our mission transcends acquisition; 
//                 we facilitate connections between discerning individuals and objects of profound beauty.
//               </p>
//             </div>
//           </div>

//           {/* Values Section - Glass Cards */}
//           <div className="grid md:grid-cols-3 gap-8 mb-20">
//             <div className="backdrop-blur-sm bg-white/5 border border-gray-800 rounded-2xl p-8 hover:bg-white/8 hover:border-gray-700 transition-all duration-500 group">
//               <div className="text-center">
//                 <div className="w-16 h-16 mx-auto mb-6 relative">
//                   <div className="absolute inset-0 bg-gradient-to-br from-yellow-400/20 to-yellow-600/20 rounded-full blur-xl group-hover:blur-2xl transition-all duration-300"></div>
//                   <div className="relative w-full h-full bg-gray-800/50 rounded-full flex items-center justify-center border border-gray-700 group-hover:border-yellow-400/50 transition-all duration-300">
//                     <svg className="w-8 h-8 text-yellow-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
//                     </svg>
//                   </div>
//                 </div>
//                 <h3 className="text-xl font-light text-white mb-4 group-hover:text-yellow-400 transition-colors duration-300">Customer First</h3>
//                 <p className="text-gray-400 font-light leading-relaxed group-hover:text-gray-300 transition-colors duration-300">
//                   Every decision we make starts with you. We listen, we care, and we adapt to make your experience extraordinary.
//                 </p>
//               </div>
//             </div>

//             <div className="backdrop-blur-sm bg-white/5 border border-gray-800 rounded-2xl p-8 hover:bg-white/8 hover:border-gray-700 transition-all duration-500 group">
//               <div className="text-center">
//                 <div className="w-16 h-16 mx-auto mb-6 relative">
//                   <div className="absolute inset-0 bg-gradient-to-br from-yellow-400/20 to-yellow-600/20 rounded-full blur-xl group-hover:blur-2xl transition-all duration-300"></div>
//                   <div className="relative w-full h-full bg-gray-800/50 rounded-full flex items-center justify-center border border-gray-700 group-hover:border-yellow-400/50 transition-all duration-300">
//                     <svg className="w-8 h-8 text-yellow-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
//                     </svg>
//                   </div>
//                 </div>
//                 <h3 className="text-xl font-light text-white mb-4 group-hover:text-yellow-400 transition-colors duration-300">Quality Products</h3>
//                 <p className="text-gray-400 font-light leading-relaxed group-hover:text-gray-300 transition-colors duration-300">
//                   We carefully source and authenticate our pieces to ensure they meet the highest standards of luxury and craftsmanship.
//                 </p>
//               </div>
//             </div>

//             <div className="backdrop-blur-sm bg-white/5 border border-gray-800 rounded-2xl p-8 hover:bg-white/8 hover:border-gray-700 transition-all duration-500 group">
//               <div className="text-center">
//                 <div className="w-16 h-16 mx-auto mb-6 relative">
//                   <div className="absolute inset-0 bg-gradient-to-br from-yellow-400/20 to-yellow-600/20 rounded-full blur-xl group-hover:blur-2xl transition-all duration-300"></div>
//                   <div className="relative w-full h-full bg-gray-800/50 rounded-full flex items-center justify-center border border-gray-700 group-hover:border-yellow-400/50 transition-all duration-300">
//                     <svg className="w-8 h-8 text-yellow-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M16 11V7a4 4 0 00-8 0v4M5 9h14l-1 12H6L5 9z" />
//                     </svg>
//                   </div>
//                 </div>
//                 <h3 className="text-xl font-light text-white mb-4 group-hover:text-yellow-400 transition-colors duration-300">Seamless Experience</h3>
//                 <p className="text-gray-400 font-light leading-relaxed group-hover:text-gray-300 transition-colors duration-300">
//                   From discovery to delivery, we've crafted a shopping experience that's sophisticated, secure, and effortlessly refined.
//                 </p>
//               </div>
//             </div>
//           </div>

//           {/* Story Section - Two Column Dark Theme */}
//           <div className="grid md:grid-cols-2 gap-12 items-center">
//             <div className="backdrop-blur-sm bg-white/5 border border-gray-800 rounded-2xl p-10 shadow-2xl">
//               <h2 className="text-3xl font-light text-white mb-6 tracking-tight">
//                 Our <span className="text-yellow-400 font-extralight italic">Story</span>
//               </h2>
//               <div className="w-16 h-px bg-gradient-to-r from-yellow-400 to-transparent mb-6"></div>
//               <div className="space-y-4 text-gray-300 font-light leading-relaxed">
//                 <p>
//                   We started with a simple idea: luxury should whisper, not shout. From our refined beginnings, we've grown into a destination 
//                   trusted by connoisseurs worldwide. What drives us? An unwavering passion for curation and a commitment to serving those who 
//                   appreciate the extraordinary.
//                 </p>
//                 <p>
//                   Whether you seek timeless essentials or rare indulgences, we promise to deliver pieces that elevate your world and reflect 
//                   your discerning taste.
//                 </p>
//               </div>
//             </div>
            
//             <div className="relative">
//               <div className="absolute inset-0 bg-gradient-to-br from-yellow-400/10 to-yellow-600/10 rounded-2xl blur-3xl"></div>
//               <div className="relative backdrop-blur-sm bg-white/5 border border-gray-800 rounded-2xl p-6 shadow-2xl">
//                 <div className="aspect-[4/3] bg-gradient-to-br from-gray-800 to-gray-900 rounded-xl flex items-center justify-center border border-gray-700">
//                   <div className="text-center">
//                     <div className="w-24 h-24 mx-auto mb-6 bg-gradient-to-br from-yellow-400/20 to-yellow-600/20 rounded-full flex items-center justify-center border border-yellow-400/30">
//                       <div className="w-8 h-8 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-full"></div>
//                     </div>
//                     <p className="text-gray-400 font-light">Crafting Exceptional Experiences</p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AboutPage;


// src/pages/AboutPage.js
import React from "react";
import Seo from "../components/seo/Seo";

const cardClassName =
  "backdrop-blur-sm bg-white/5 border border-gray-800 rounded-lg md:rounded-xl p-3 md:p-6 text-center hover:bg-white/10 transition";

const iconWrapperClassName =
  "w-9 h-9 md:w-12 md:h-12 mx-auto mb-2 md:mb-4 bg-gray-800/50 rounded-full flex items-center justify-center border border-gray-700";

const titleClassName =
  "text-xs sm:text-lg font-medium text-white mb-1 md:mb-2";

const bodyClassName =
  "text-gray-400 text-[11px] sm:text-sm leading-snug md:leading-relaxed";

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-black py-12">
      <Seo
        title="About JmoLux"
        description="Learn about JmoLux, our focus on premium skincare, elevated customer care and carefully curated daily essentials."
        path="/about"
      />
      <div className="container mx-auto px-6 max-w-6xl">
        {/* Story Section */}
        <div className="backdrop-blur-sm bg-white/5 border border-gray-800 rounded-xl p-6 md:p-8 text-center max-w-3xl mx-auto mb-6 md:mb-10 shadow-lg">
          <h1 className="text-xl sm:text-2xl md:text-3xl font-light text-white mb-4">
            Our <span className="text-yellow-400 italic">Story</span>
          </h1>
          <p className="text-gray-300 text-sm sm:text-base leading-relaxed mb-3">
            We started with a simple idea: luxury should whisper, not shout.
            From our refined beginnings, we've grown into a destination trusted
            by connoisseurs worldwide.
          </p>
          <p className="text-gray-300 text-sm sm:text-base leading-relaxed">
            Whether you seek timeless essentials or rare indulgences, we promise
            to deliver pieces that elevate your world and reflect your
            discerning taste.
          </p>
        </div>

        <div className="grid grid-cols-2 gap-3 md:gap-6 mb-10 md:mb-14">
          <div className={cardClassName}>
            <div className={iconWrapperClassName}>
              <svg
                className="w-4 h-4 md:w-6 md:h-6 text-yellow-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1.5}
                  d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
            <h3 className={titleClassName}>Our Mission</h3>
            <p className={bodyClassName}>
              We connect customers with carefully selected skincare and
              essentials that bring quality and confidence to everyday life.
            </p>
          </div>

          <div className={cardClassName}>
            <div className={iconWrapperClassName}>
              <svg
                className="w-4 h-4 md:w-6 md:h-6 text-yellow-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1.5}
                  d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7"
                />
              </svg>
            </div>
            <h3 className={titleClassName}>Our Legacy</h3>
            <p className={bodyClassName}>
              JmoLux is built on thoughtful curation, authenticity, and lasting
              trust. We believe luxury should feel refined and purposeful.
            </p>
          </div>
          <div className={cardClassName}>
            <div className={iconWrapperClassName}>
              <svg
                className="w-4 h-4 md:w-6 md:h-6 text-yellow-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1.5}
                  d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 
                     0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 
                     3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-
                     1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 
                     11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 
                     014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                />
              </svg>
            </div>
            <h3 className={titleClassName}>
              Customer First
            </h3>
            <p className={bodyClassName}>
              Every decision starts with our customers. We listen carefully and
              provide dependable, personal support.
            </p>
          </div>

          <div className={cardClassName}>
            <div className={iconWrapperClassName}>
              <svg
                className="w-4 h-4 md:w-6 md:h-6 text-yellow-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1.5}
                  d="M11.049 2.927c.3-.921 
                     1.603-.921 1.902 0l1.519 4.674a1 1 0 
                     00.95.69h4.915c.969 0 1.371 1.24.588 
                     1.81l-3.976 2.888a1 1 0 
                     00-.363 1.118l1.518 4.674c.3.922-.755 
                     1.688-1.538 1.118l-3.976-2.888a1 1 0 
                     00-1.176 0l-3.976 2.888c-.783.57-1.838-
                     .197-1.538-1.118l1.518-4.674a1 1 0 
                     00-.363-1.118l-3.976-2.888c-.784-.57-.38-
                     1.81.588-1.81h4.914a1 1 0 
                     00.951-.69l1.519-4.674z"
                />
              </svg>
            </div>
            <h3 className={titleClassName}>
              Quality Products
            </h3>
            <p className={bodyClassName}>
              We select products for quality, performance, and everyday value
              so you can shop with confidence.
            </p>
          </div>
        </div>

      </div>
    </div>
  );
};

export default AboutPage;
